namespace Matrix.Indexation {
    export interface FactIndexConstituentRorRow {
        IndexationProfileKey?: number;
        CompositeKey?: number;
        IndexKey?: number;
        BaseDate?: string;
        EffectiveDate?: string;
        SourceCode?: string;
        LocalReturn?: number;
        CurrencyReturn?: number;
        HedgedReturn?: number;
        UnhedgedReturn?: number;
        TotalReturn?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        DefaultSortOrder?: number;
        CompositeIndexCode?: string;
        CompositeName?: string;
        CompositeGeneration?: number;
        CompositeIsCurrent?: string;
        CompositeEffectiveFrom?: string;
        CompositeEffectiveTo?: string;
        CompositeLocalCurrencyCode?: string;
        CompositeIndexTypeCode?: string;
        CompositePriceSource1?: string;
        CompositePriceSource1Id?: string;
        CompositePriceSource2?: string;
        CompositePriceSource2Id?: string;
        CompositeFxOtherCurrency?: string;
        CompositeRowId?: number;
        CompositeDefaultSortOrder?: number;
        IndexCode?: string;
        IndexName?: string;
        IndexGeneration?: number;
        IndexIsCurrent?: string;
        IndexEffectiveFrom?: string;
        IndexEffectiveTo?: string;
        IndexLocalCurrencyCode?: string;
        IndexTypeCode?: string;
        IndexPriceSource1?: string;
        IndexPriceSource1Id?: string;
        IndexPriceSource2?: string;
        IndexPriceSource2Id?: string;
        IndexFxOtherCurrency?: string;
        IndexRowId?: number;
        IndexDefaultSortOrder?: number;
        SourceName?: string;
        SourceGroup?: string;
        SourceCategory?: string;
        SourceId?: number;
        SourceRowId?: number;
    }

    export namespace FactIndexConstituentRorRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'SourceCode';
        export const localTextPrefix = 'Indexation.FactIndexConstituentRor';
        export const deletePermission = 'DataAdmin:FactIndexConstituentRor';
        export const insertPermission = 'DataAdmin:FactIndexConstituentRor';
        export const readPermission = 'Read:FactIndexConstituentRor';
        export const updatePermission = 'DataAdmin:FactIndexConstituentRor';

        export declare const enum Fields {
            IndexationProfileKey = "IndexationProfileKey",
            CompositeKey = "CompositeKey",
            IndexKey = "IndexKey",
            BaseDate = "BaseDate",
            EffectiveDate = "EffectiveDate",
            SourceCode = "SourceCode",
            LocalReturn = "LocalReturn",
            CurrencyReturn = "CurrencyReturn",
            HedgedReturn = "HedgedReturn",
            UnhedgedReturn = "UnhedgedReturn",
            TotalReturn = "TotalReturn",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            DefaultSortOrder = "DefaultSortOrder",
            CompositeIndexCode = "CompositeIndexCode",
            CompositeName = "CompositeName",
            CompositeGeneration = "CompositeGeneration",
            CompositeIsCurrent = "CompositeIsCurrent",
            CompositeEffectiveFrom = "CompositeEffectiveFrom",
            CompositeEffectiveTo = "CompositeEffectiveTo",
            CompositeLocalCurrencyCode = "CompositeLocalCurrencyCode",
            CompositeIndexTypeCode = "CompositeIndexTypeCode",
            CompositePriceSource1 = "CompositePriceSource1",
            CompositePriceSource1Id = "CompositePriceSource1Id",
            CompositePriceSource2 = "CompositePriceSource2",
            CompositePriceSource2Id = "CompositePriceSource2Id",
            CompositeFxOtherCurrency = "CompositeFxOtherCurrency",
            CompositeRowId = "CompositeRowId",
            CompositeDefaultSortOrder = "CompositeDefaultSortOrder",
            IndexCode = "IndexCode",
            IndexName = "IndexName",
            IndexGeneration = "IndexGeneration",
            IndexIsCurrent = "IndexIsCurrent",
            IndexEffectiveFrom = "IndexEffectiveFrom",
            IndexEffectiveTo = "IndexEffectiveTo",
            IndexLocalCurrencyCode = "IndexLocalCurrencyCode",
            IndexTypeCode = "IndexTypeCode",
            IndexPriceSource1 = "IndexPriceSource1",
            IndexPriceSource1Id = "IndexPriceSource1Id",
            IndexPriceSource2 = "IndexPriceSource2",
            IndexPriceSource2Id = "IndexPriceSource2Id",
            IndexFxOtherCurrency = "IndexFxOtherCurrency",
            IndexRowId = "IndexRowId",
            IndexDefaultSortOrder = "IndexDefaultSortOrder",
            SourceName = "SourceName",
            SourceGroup = "SourceGroup",
            SourceCategory = "SourceCategory",
            SourceId = "SourceId",
            SourceRowId = "SourceRowId"
        }
    }
}
